

exports.__esModule = true;
exports.$xoSidebarInstallmentOptionsPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-page-components/src/aside-header/directive');

require('components/xo-wallet-components/src/installment-options/directive');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarInstallmentOptionsPageComponent = exports.$xoSidebarInstallmentOptionsPageComponent = _squid.$Component.extend('$xoSidebarInstallmentOptionsPageComponent', {
    tag: 'xo-sidebar-installment-options-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $state) {
        $scope.token = $rootScope.token;

        $scope.onComplete = function () {
            $state.go('checkout.review');
        };

        $scope.$emit('populated');
    }
});

angular.value("$xoSidebarInstallmentOptionsPageComponent", $xoSidebarInstallmentOptionsPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-installment-options/directive.js
// module id = ./pages/xo-sidebar-installment-options/directive.js
// module chunks = 1